import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {PremiumCrownChipProps} from './premium-crown-chip.types';
import styles from './premium-crown-chip.module.scss';

/**
 * The round premium crown badge that overhangs the top-right corner of the element it upsells.
 * The parent supplies the positioning context (`_position-relative`).
 */
export function PremiumCrownChip({className = ''}: PremiumCrownChipProps): ReactElement {
  return (
    <span className={`${styles.premiumCrownChip} ${className}`}>
      <Icon icon="icon-crown" type={IconType.NONE} size={IconSize.SIZE_ICON_12} className={styles.premiumCrownChipIcon} />
    </span>
  );
}
